import { EcModule } from "./module";
import { EbUser } from "./user";

export class ExUserModule {

	module: EcModule;
	ebUser: EbUser;
	accessRight : number;
	xEcModule : number;

	constructor(xEcModule?: number){
		this.ebUser = null;
		this.accessRight = null;
		this.xEcModule = xEcModule || null;
		if(xEcModule){
			this.module = new EcModule();
			this.module.ecModuleNum = xEcModule;
		}
		else
			this.module = null;

	}


	constructorCopy(exUserModule:ExUserModule){
		this.module = exUserModule.module;
		this.ebUser = exUserModule.ebUser;
		this.accessRight = exUserModule.accessRight;
		this.xEcModule = exUserModule.module.ecModuleNum;
	}
}



// WEBPACK FOOTER //
// ./src/app/classes/accessRight.ts